// Lightweight, anonymous funnel tracking.
// Fires fire-and-forget POSTs to /api/analytics/event. Never blocks UI.
// SessionId persists in localStorage so we can dedupe pageviews to unique
// visitors in the Admin → Overview Conversion Report.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'sc365_session_id';

function getOrCreateSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        (crypto?.randomUUID && crypto.randomUUID()) ||
        `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function trackEvent(type, meta) {
  if (!BACKEND_URL) return;
  try {
    const sessionId = getOrCreateSessionId();
    fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, sessionId, meta: meta || {} }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never let analytics break the page */
  }
}

export { getOrCreateSessionId };
